import * as tslib_1 from "tslib";
import { Component, Prop, Watch, Model } from "vue-property-decorator";
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
import SearchPanel from "./search-panel.vue";
import { H3Checkbox, H3Avatar, H3Button } from "h3-mobile-vue";
// import * as list from '@cloudpivot/list'
let RelevanceFormModal = class RelevanceFormModal extends RelevanceFormControl {
    // import * as list from '@cloudpivot/list'
    constructor() {
        super(...arguments);
        this.count = 0;
        this.multiValue = [];
        this.checkedArr = [];
        this.queryConditions = [];
        this.queryColumns = [];
        this.queryResult = [];
        this.queryActions = [];
        this.initDataTimeout = null;
    }
    onValueChange(nVal) {
        if (Array.isArray(nVal) && nVal.length === 0) {
            this.checkedArr = [];
        }
        else if (nVal && nVal.id) {
            this.checkedArr = nVal.id.split(";");
            this.count = this.checkedArr.length;
            this.change(this.checkedArr, true);
        }
    }
    onCheckedArrChange(nVal, oVal) {
        this.count = nVal.length;
    }
    onVisibleChange(nVal) {
        if (nVal) {
            this.getListQueryConditions(true).then((res) => {
                if (res) {
                    this.queryConditions = res.conditions;
                    this.queryColumns = res.queryColumns;
                    this.queryActions = res.queryActions;
                }
                else {
                    this.queryConditions = [];
                }
            });
            this.initData();
        }
    }
    initData() {
        const searchPanelMulti = this.$refs.searchPanelMulti;
        if (this.initDataTimeout) {
            clearTimeout(this.initDataTimeout);
        }
        if (searchPanelMulti) {
            searchPanelMulti.reFetch();
        }
        else {
            this.initDataTimeout = setTimeout(() => {
                this.initData();
            }, 100);
        }
    }
    back() {
        this.$emit("back");
    }
    getCreater(item) {
        if (Array.isArray(item.creater)) {
            if (item.creater.length > 0) {
                return item.creater[0];
            }
        }
        return {};
    }
    change(item, isChecked) {
        let tempArr = [];
        if (Array.isArray(item)) {
            item.forEach(x => {
                let curItem = this.queryResult.find((z) => {
                    return z.id === x;
                });
                if (!curItem) {
                    curItem = this.multiValue.find((z) => {
                        return z.id === x;
                    });
                }
                curItem && tempArr.push(curItem);
            });
        }
        this.multiValue = tempArr;
    }
    superFetch(page, pageSize, value, formState) {
        let query = [];
        if (formState) {
            query = [formState];
            return;
        }
        else {
            query = this.queryFormData;
        }
        return this.fetch(page, pageSize, value, query, true);
    }
    getStatus(status) {
        const txt = this.$t(`cloudpivot.form.renderer.formStatus.${status.toLowerCase()}`);
        return txt;
        // switch (status) {
        //   case "DRAFT":
        //     return "草稿";
        //   case "PROCESSING":
        //     return "进行中";
        //   case "COMPLETED":
        //     return "已完成";
        //   case "CANCELED":
        //     return "已作废";
        //   default:
        //     return "";
        // }
    }
    showFilterPanel(show) {
        //   if(show){
        //     this.getListQueryConditions().then(res => {
        //       this.queryConditions = res || [];
        //     });
        //   }
    }
    onFilter(query) {
        // this.queryFormData = query.map(x => ({
        //   code : x.propertyCode,
        //   type : x.propertyType,
        //   value : x.propertyValue
        // }));
        this.queryFormData = query;
        const searchPanelMulti = this.$refs.searchPanelMulti;
        if (searchPanelMulti) {
            searchPanelMulti.reFetch();
        }
    }
    confirm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.$emit("back");
            let item = yield this.convertForMappings(this.multiValue.map(item => item.data));
            this.$emit("change", item);
        });
    }
    notifyRes(list) {
        this.queryResult = list;
    }
    openRelevanced() {
        let returnPath = `/form/detail?schemaCode=${this.$route.query.schemaCode}&return=/apps/apps-form-list/${this.$route.query.schemaCode}`;
        returnPath = encodeURI(returnPath);
        this.$router.push({
            path: '/form/detail',
            query: {
                startWorkflowCode: this.startWorkflowCode,
                schemaCode: this.control.options.schemaCode,
                return: returnPath,
            },
        });
    }
    beforeCreate() {
        this
            .$options.components.FormStatus = RelevanceFormControl.loadFormStatus();
        this
            .$options.components.QueryForm = RelevanceFormControl.loadQueryForm();
        this
            .$options.components.FormItem = RelevanceFormControl.loadFormItem();
    }
    get canAdd() {
        let addFlag = this.queryActions.some(v => v.actionCode == "add");
        return addFlag;
    }
    get startWorkflowCode() {
        const addAction = this.queryActions.find((v) => v.actionCode === 'add');
        if (addAction.associationType === 1) {
            return addAction.associationCode;
        }
        else {
            return '';
        }
    }
};
tslib_1.__decorate([
    Prop({
        default: false
    })
], RelevanceFormModal.prototype, "visible", void 0);
tslib_1.__decorate([
    Model("change")
], RelevanceFormModal.prototype, "value", void 0);
tslib_1.__decorate([
    Watch("value", {
        immediate: true
    })
], RelevanceFormModal.prototype, "onValueChange", null);
tslib_1.__decorate([
    Watch("checkedArr")
], RelevanceFormModal.prototype, "onCheckedArrChange", null);
tslib_1.__decorate([
    Watch("visible")
], RelevanceFormModal.prototype, "onVisibleChange", null);
RelevanceFormModal = tslib_1.__decorate([
    Component({
        name: "relevance-form-modal",
        components: {
            SearchPanel,
            H3CheckboxItem: H3Checkbox.Item,
            H3Avatar,
            H3Button
            // FormItem: list.components.mobile.FormItem
        },
        directives: {
        // TransferDom
        }
    })
], RelevanceFormModal);
export default RelevanceFormModal;
